import { defineMessages } from "react-intl";

export const messages = defineMessages({
    criticalErrorCustomText: {
        id: "fastshift.home-page.critical-error-display.custom-text",
        defaultMessage: "We’re unable to load this page right now.",
        description:
            "Alt Text for the generic error vector graphic displayed when an unknown error occurs"
    }
});
